export const breakpointNames = ['mobile', 'tablet', 'desktop', 'wide'] as const;

export const breakpoints = {
  mobile: 0,
  tablet: 720,
  desktop: 992,
  // Onboarding rebrand splits its layout padding at 1080px; expose that so
  // rebrand surfaces don't have to inline a custom media query.
  wide: 1080,
} as const;

export type Breakpoint = keyof typeof breakpoints;
